var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFaceNeutralGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47778 20 0 15.5228 0 10C0 4.47778 4.47778 0 10 0C15.5228 0 20 4.47778 20 10Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38889 11.1115C7.15595 11.1115 7.77778 10.241 7.77778 9.1671C7.77778 8.09321 7.15595 7.22266 6.38889 7.22266C5.62183 7.22266 5 8.09321 5 9.1671C5 10.241 5.62183 11.1115 6.38889 11.1115Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6111 11.1115C14.3781 11.1115 14.9999 10.241 14.9999 9.1671C14.9999 8.09321 14.3781 7.22266 13.6111 7.22266C12.844 7.22266 12.2222 8.09321 12.2222 9.1671C12.2222 10.241 12.844 11.1115 13.6111 11.1115Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.889 14.4441H6.11122C5.80455 14.4441 5.55566 14.1958 5.55566 13.8886C5.55566 13.5813 5.80455 13.333 6.11122 13.333H13.889C14.1962 13.333 14.4446 13.5813 14.4446 13.8886C14.4446 14.1958 14.1962 14.4441 13.889 14.4441Z",
    fill: "#664500"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFaceNeutralGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-face-neutral-grey.62aa14897aa0f1b02cb4656eb2e11c76.svg";